<div class="navigation-container screen-navigation-container">
  <div class="d-flex justify-content-between">
    <div class="col-3 pe-3">
      <button class="btn btn-back btn-default btn-block btn-screen-navigation w-100" *ngIf="isBackButtonVisible"
              (click)="onPreviousClick()">
        <span> {{ 'screen.navigation.previous' | translate }} </span>
      </button>
    </div>
    <div class="col-9 p-0">
      <div class="row mx-0 flex justify-content-lg-center justify-content-end">
        <div class="w-75 pe-0">
          <button class="btn btn-lg btn-next btn-block btn-screen-navigation w-100"
                  [ngClass]="{ 'btn-disabled': isNextButtonDisabled }" [disabled]="isNextButtonDisabled"
                  (click)="onNextClick()">
            <span *ngIf="!isLoadingData"> {{ 'screen.navigation.next' | translate }} </span>
            <app-loader *ngIf="isLoadingData" [config]="config" backdrop-position="relative" size="small"></app-loader>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>